export enum PhoneNumberCountries {
  CH,
  FR,
  IT,
  DE,
}

/**
 * The different consent text with abbreviation coming from the ConfigItem
 */
export enum ConsentText {
  AssessmentDocuments = 'AD',
  Basic = 'B',
  CancerRegistry = 'CR',
  DataProcessing = 'DP',
  ExternalPhysician = 'EP',
  ProgramMigration = 'PM',
  StatisticalUse = 'SU',
}

/**
 * Get the enum Key (as a string) by the given enum Value
 * TODO: move this method elsewhere as a helper ?
 * @param myEnum The enum
 * @param enumValue The value
 * @returns {String} The enum key as a string
 */
export function getEnumKeyByEnumValue(myEnum: any, enumValue: any) {
  const keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}

/**
 * The different enum for the health questionnaire
 */
export enum AnswerChoices {
  No = 'NON',
  Yes = 'OUI',
  DontKnow = 'SAIS_PAS',
  Other = 'AUTRE',
  Unknown = 'INCONNU',
  Screening = 'DEPIST',
  BreastProblem = 'PB_SEIN',
  BeforeHT_No = 'QF_FTHB_NO',
  BeforeHT_NoSince = 'QF_FTHB_NO_SINCE',
  BeforeHT_NoAnswer = 'QF_FTHB_NO_ANSWER',
}

export enum Breast {
  Both = '2S',
  Right = 'SD',
  Left = 'SG',
}

export enum CancerFamilyChoices {
  DontKnow = 'SAIS_PAS',
  LessThan50 = 'MOINS_50',
  MoreThan50 = 'PLUS_50'
}

export enum BreastSymptom {
  Pain,
  Flow,
  Boule,
  Other
}

export enum BreastOperation {
  BenignAffection,
  Cancer,
  PlasticSurgery,
  Other
}
